import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Stack, ShipsIcon, StorageIcon, TrendingUpIcon } from '@esgian/esgianui';
import { OwnersTable } from '@components/Tables';
import { useQuery } from '@tanstack/react-query';
import { getOwnerStats } from '@api';
import { useSelector } from 'react-redux';
import { getSegment } from '@store/features';
import KpiBox from '@components/Display/KpiBox';
import { formatNumberReadable, parseNumberToSignificant } from '@helpers';
import { toast } from 'react-toastify';

function OwnerOverviewSection() {
  const segment = useSelector(getSegment);

  const ownerStatsQuery = useQuery({
    queryKey: ['ownerStats', segment.id],
    enabled: true,
    placeholderData: null,
    queryFn: ({ queryKey, signal }) => {
      return getOwnerStats({ SegmentTypeId: queryKey[1] }, signal)
        .then((response) => {
          return response;
        })
        .catch(() => {
          toast.error(`Unable to fetch owner data`, {
            position: 'top-right'
          });
          return null;
        });
    }
  });

  const { owners, fleetSize, averageAge, averageCapacity, totalCapacity } =
    ownerStatsQuery.data || {};
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Stack
          direction="row"
          spacing={1} // Applies spacing between items on the same row
          useFlexGap
          sx={{ flexWrap: 'wrap' }}>
          <KpiBox
            loading={ownerStatsQuery.isFetching}
            icon={<ShipsIcon />}
            value={fleetSize ? fleetSize : ''}
            title={'Fleet Size'}
            subtitle={'Vessels'}
          />
          <KpiBox
            loading={ownerStatsQuery.isFetching}
            icon={<TrendingUpIcon />}
            value={averageAge ? parseNumberToSignificant(averageAge) : ''}
            title={'Average Age'}
            subtitle={'Years'}
          />
          <KpiBox
            loading={ownerStatsQuery.isFetching}
            icon={<StorageIcon />}
            value={averageCapacity ? formatNumberReadable(parseInt(averageCapacity)) : '-'}
            title={'Average Capacity'}
            subtitle={'CEU'}
          />
          <KpiBox
            loading={ownerStatsQuery.isFetching}
            icon={<StorageIcon />}
            value={totalCapacity ? formatNumberReadable(totalCapacity) : ''}
            title={'Total Capacity'}
            subtitle={'CEU'}
          />
        </Stack>
      </Grid>

      <Grid item xs={12}>
        <OwnersTable owners={owners} loading={ownerStatsQuery.isFetching} />
      </Grid>
    </Grid>
  );
}

OwnerOverviewSection.propTypes = {};

export default OwnerOverviewSection;
